import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgStatusAppApproval = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#2D2E2E"
      d="M14 0h-2v3h2V0Zm6.19 3-1.53-1.3L16.73 4l1.54 1.28L20.19 3ZM9.27 4 7.34 1.7 5.81 3l1.92 2.3L9.27 4ZM19 10h-4V7a2 2 0 0 0-2-2h-1.43L6 11.64V19h2v-6.64L12.5 7h.5v5h6a1 1 0 0 1 1 1v2.68L15.53 21H6v2h10.47L22 16.4V13a3 3 0 0 0-3-3ZM2 23h2V12H2v11Z"
    />
  </svg>
);
export default SvgStatusAppApproval;
